





































import Vue from 'vue'

import { AddImageStates, ERROR_CONTENTS, ErrorContent } from '@/common/constants/imageUpload'

export default Vue.extend({
  props: {
    addImageState: {
      type: String,
      required: true
    }
  },
  computed: {
    errorContents(): ErrorContent {
      return Object.values(ERROR_CONTENTS).filter(
        item => item.errorState === this.addImageState
      )[0]
    }
  },
  methods: {
    backToUpload() {
      this.$emit('updateState', AddImageStates.IDLE)
    }
  }
})
